// extracted by mini-css-extract-plugin
export default {"responses":"F0XBF9","response":"EcOCo3"};